// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transfer-chat__operator-item {
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: row;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none;   /* Chrome/Safari/Opera */
    -khtml-user-select: none;    /* Konqueror */
    -moz-user-select: none;      /* Firefox */
    -ms-user-select: none;       /* Internet Explorer/Edge */
    user-select: none;
    cursor: pointer;
}

.operator-item__operator-info p {
    margin: 0;
    color: black;
    line-height: 1.1;
    text-align: left;
}

.transfer-chat__operator-item .operator-item__operator-info {
    margin-left: .5rem;
    margin-top: .3rem;
    min-width: 0;
}

.operator-item__operator-info .operator-item__tier {
    color: darkblue !important;
}

.operator-item__operator-info .operator-item__tier-supervisor {
    color: darkred;
}

.transfer-chat__operator-item .operator-item__operator-avatar {
    width: 7.3rem !important;
    height: 7.3rem !important;
    border-radius: 50%;
    border: 1px solid;
    float: left;
    margin: auto 0;
}

.transfer-chat__operator-item .operator-item__operator-avatar.offline {
    border: 1px solid red;
}

.transfer-chat__operator-item .operator-item__operator-avatar.online {
    border: 1px solid #0F0;
}

.transfer-chat__operator-item .operator-item__operator-avatar.pause {
    border: 1px solid #DD0;
}

.operator-item__selected-icon {
    margin: auto 0;
    margin-left: auto;
}

.transfer-chat__operator-item .operator-item__status-online {
    color: #00FF0080 !important;
}

.transfer-chat__operator-item .operator-item__status-pause {
    color: #FFA500 !important;
}

.transfer-chat__operator-item--avatar-container {
    display: flex;
    flex-direction: column;
}

.operator-item__status-row {
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.transfer-chat__operator-item .operator-item__status {
    display: block;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/app/chat/transfer-chat/transfer-chat-operator-item/TransferChatOperatorItem.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,IAAI,wBAAwB;IACrD,wBAAwB,KAAK,cAAc;IAC3C,sBAAsB,OAAO,YAAY;IACzC,qBAAqB,QAAQ,2BAA2B;IACxD,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".transfer-chat__operator-item {\r\n    margin-bottom: 1.5rem;\r\n    display: flex;\r\n    flex-direction: row;\r\n    -webkit-touch-callout: none; /* iOS Safari */\r\n    -webkit-user-select: none;   /* Chrome/Safari/Opera */\r\n    -khtml-user-select: none;    /* Konqueror */\r\n    -moz-user-select: none;      /* Firefox */\r\n    -ms-user-select: none;       /* Internet Explorer/Edge */\r\n    user-select: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.operator-item__operator-info p {\r\n    margin: 0;\r\n    color: black;\r\n    line-height: 1.1;\r\n    text-align: left;\r\n}\r\n\r\n.transfer-chat__operator-item .operator-item__operator-info {\r\n    margin-left: .5rem;\r\n    margin-top: .3rem;\r\n    min-width: 0;\r\n}\r\n\r\n.operator-item__operator-info .operator-item__tier {\r\n    color: darkblue !important;\r\n}\r\n\r\n.operator-item__operator-info .operator-item__tier-supervisor {\r\n    color: darkred;\r\n}\r\n\r\n.transfer-chat__operator-item .operator-item__operator-avatar {\r\n    width: 7.3rem !important;\r\n    height: 7.3rem !important;\r\n    border-radius: 50%;\r\n    border: 1px solid;\r\n    float: left;\r\n    margin: auto 0;\r\n}\r\n\r\n.transfer-chat__operator-item .operator-item__operator-avatar.offline {\r\n    border: 1px solid red;\r\n}\r\n\r\n.transfer-chat__operator-item .operator-item__operator-avatar.online {\r\n    border: 1px solid #0F0;\r\n}\r\n\r\n.transfer-chat__operator-item .operator-item__operator-avatar.pause {\r\n    border: 1px solid #DD0;\r\n}\r\n\r\n.operator-item__selected-icon {\r\n    margin: auto 0;\r\n    margin-left: auto;\r\n}\r\n\r\n.transfer-chat__operator-item .operator-item__status-online {\r\n    color: #00FF0080 !important;\r\n}\r\n\r\n.transfer-chat__operator-item .operator-item__status-pause {\r\n    color: #FFA500 !important;\r\n}\r\n\r\n.transfer-chat__operator-item--avatar-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.operator-item__status-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.4rem;\r\n}\r\n\r\n.transfer-chat__operator-item .operator-item__status {\r\n    display: block;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
